
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notices",
      function () {
        return require("private-next-pages/notices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notices"])
      });
    }
  